import { put } from "redux-saga/effects";
import { begin, end, pendingTask } from "react-redux-spinner";
import {
  IUpdateUserAuthorizations,
  adminUserUpdateResponse
} from "../../admin.actions";
import AdminService from "../../admin.service";
import AdminFeedback from "../../admin.feedback";

export function* updateAuthorizations(action: IUpdateUserAuthorizations) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });
  try {
    const { userId, claims } = action.payload;
    const adminService = new AdminService();
    const user = yield adminService.updateUserAuthorizations(userId, claims);
    yield put(
      adminUserUpdateResponse(user, AdminFeedback.AUTHORIZATIONS_UPDATED)
    );
  } catch (error) {
    yield put(
      adminUserUpdateResponse(error, AdminFeedback.AUTHORIZATIONS_UPDATE_FAILED)
    );
  }

  yield put({ type: "SPINNER", [pendingTask]: end });
}
